import type { Bounds, Range } from 'quill/core';
import { isCellManager } from '../formats/utils/CellManager';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function getRangeBoundaries(quill: any, range: Range): Bounds[] | null {
  if (range.length <= 1) {
    const [leaf] = quill.getLeaf(range.index);

    if (isCellManager(leaf)) {
      const identity = leaf.getActiveCellIdentity();
      if (identity) {
        const rangeInCell = leaf.getCellLastRange(identity);
        return (
          rangeInCell && leaf.getCellClientRects({ identity, ...rangeInCell })
        );
      }
      return null;
    }
    if (leaf?.statics.blotName === 'code-embed') {
      if (leaf.isPreviewing) {
        const index = leaf.offset(quill.scroll);
        return index >= 0 ? quill.getClientRects(index, 1) : null;
      }
      const rangeInCode = leaf.getLastRange();
      return rangeInCode && leaf.getClientRects(rangeInCode);
    }
  }

  return quill.getClientRects(range.index, range.length);
}

export default getRangeBoundaries;
